import loginProps from "common/managers/loginProps";
import dateConvert from "common/helper/dateConvert";
import DataType from "common/enums/DataType";
import PromptInputType from "common/enums/PromptInputType";
var apply = {

    /**
     * Convert a value to a form allowed for that prompt.
     * @param prompt Prompt
     * @param value Value
     * @returns {*}
     */
    convertValue: function(prompt, value) {
        if (prompt.dataType === DataType.DATE) {
            return this._convertDateInputToValue(prompt, value);
        } else if (prompt.dataType === DataType.BOOLEAN) {
            return value === "true" || value === true;
        } else if (prompt.allowMultipleValues && (value === null || value === undefined || value === "")) {
            return null;
        } else if (prompt.allowMultipleValues) {
            // value could be an array or list already, but if not, split the string using the delimiter in the system property
            if(value.split) {
                return value.split(this._getDelimiter());
            } else {
                return value;
            }
        } else if(value === undefined && prompt.dataType === DataType.STRING && prompt.inputType === PromptInputType.LIST && !prompt.listEditable) {
            return null;
        } else if(value === undefined && prompt.dataType === DataType.STRING) {
            return "";
        } else if(value === undefined && (prompt.dataType === DataType.INTEGER || prompt.dataType === DataType.DECIMAL)) {
            return null;
        } else {
            return value;
        }
    },

    /**
     * Convert a given date input into a proper long value for a prompt.
     * 
     * This does a best effort attempt at getting a match out of the prompt data
     * @param prompt
     * @param value
     * @private
     */
    _convertDateInputToValue: function(prompt, value) {
        var data = prompt.data;

        // Find a moment in time match in the data
        var findMomentInTime = function(targetLong) {
            if (data && data.length) {
                var exact = data.filter(function(item) {
                    return item.value === targetLong;
                });
                if (exact.length > 0) {
                    return exact[0].value;
                }
            }
            return null;
        };

        // Find a server date match in the data
        var findDate = function(targetDate) {
            if (data && data.length) {
                var possible = data.filter(function(item) {
                    var d = dateConvert.toDate(item.value);
                    if (targetDate === null || d === null) {
                        return false;
                    } else {
                        return d.getFullYear() == targetDate.getFullYear() && d.getMonth() == targetDate.getMonth() && d.getDate() == targetDate.getDate();
                    }
                });
                if (possible.length >= 1) {
                    return possible[0].value;
                }
            }
            return null;
        };

        //System neutral handling
        var date = dateConvert.neutralToDate(value);
        if (date !== null) {
            // if the input format is system neutral check for a date based on server's timezone
            // all of the work is needed to ensure a match if the input data isn't set to 12pm
            var result = findDate(date);
            if (result !== null) {
                return result;
            } else {
                //no match in data, so just return the timestamp for 12pm on this date in the server's timezone
                return dateConvert.toLong(date);
            }
        } else {
            //long handling. Start by checking for an exact moment in time match
            var momentDate = dateConvert.toDateUsingClientsTimeZone(value);
            var stamp = dateConvert.toLongUsingClientsTimeZone(momentDate);
            var exactMatch = findMomentInTime(stamp);
            if (exactMatch !== null) {
                return exactMatch;
            } else {
                //fall back to checking for a loose match based on server's timezone
                var normalizedDate = dateConvert.toDate(value);
                var looseMatch = findDate(normalizedDate);
                if (looseMatch !== null) {
                    return looseMatch;
                } else {
                    // there is no match in any of the data, so fallback to returning the value, except conversion to a number has happened
                    return stamp;
                }
            }
        }
    },

    _getDelimiter: function() {
        var ret = ",";
        if (loginProps && loginProps.get() && loginProps.get().searchingDelimiterIn) {
            ret = loginProps.get().searchingDelimiterIn;
        }
        return ret;
    },

    /**
     * Determine if a value is correctly formatted for a particular prompt.
     * @param dataType
     * @param value
     */
    isValueCorrectType: function(dataType, value) {
        if (value === "" || value === undefined || value === null) {
            return true;
        } else if (dataType == DataType.BOOLEAN) {
            return (value === true || value == "true" || value === false || value == "false");
        } else if (dataType == DataType.DECIMAL) {
            var num = kendo.parseFloat(value);
            return num !== null && ((("" + num).length >= ("" + value).length) || /0$/.test("" + value));
        } else if (dataType == DataType.INTEGER) {
            var i = kendo.parseInt(value),
                j = Number(value);
            return i !== null && j !== null && i == j;
        } else if (dataType == DataType.DATE) {
            return value instanceof Date || dateConvert.neutralToLong(value) !== null;
        } else {
            return true;
        }
    },

    /**
     * Apply an arbitrary value to a prompt.
     * @param prompt
     * @param value
     * @return {boolean} True if value was correctly typed. False if value had to be skipped
     */
    applyValue: function(prompt, value) {
        if (this.isValueCorrectType(prompt.dataType, value)) {
            var val = apply.convertValue(prompt, value);
            prompt.set("value", val);
            if(prompt.blindEntry) {
                prompt.set("blindValue", val);
            }
            return true;
        } else {
            return false;
        }
    },

    /**
     * Apply default value to a single prompt.  This should be used only if the datasource/macro for a prompt has NOT been executed.
     * @param prompt
     */
    applyDefaultValue: function(prompt) {
        var def = prompt.get("strDefaultValue");
        if(prompt.get("value") === undefined) {
            apply.applyValue(prompt, def);
        }
    },

    /**
     * Apply all default values.
     * @param prompts
     */
    applyDefaultValues: function(prompts) {
        prompts.forEach(function(p) {
            apply.applyDefaultValue(p);
        });
    }
};
export default apply;
